import GameManager from './GameManager';

/**
 * Base environment class. An environment is basically the renderer, or what displays the game.
 */
export class Environment<TProps> {

    public props: TProps;

    public getDefaultProps(): TProps {
    	throw new Error('getDefaultProps must be implemented');
    }

	/**
     * True if the environment is ready.
     */
	public get isReady(): boolean {
		return this._isReady;
	}

    public blurFadeIn(): void {
    	throw new Error('blurFadeIn must be implemented');
	}

	public blurFadeOut(): void {
    	throw new Error('blurFadeOut must be implemented');
	}

    /**
     * True if the environment is ready.
     */
    private _isReady: boolean = false;

    /**
     * ctor
     * @param gameManager A reference to the game manager
     * @param onReady Optional. Called when the environment is ready to render
     */
    constructor(public gameManager: GameManager, public onReady?: () => void) {
    	this._isReady = false;
    }

    /**
     * Marks wthe environment as ready to render
     */
    public markReady(): void {
    	this._isReady = true;
    	if(this.onReady) {
    		this.onReady();
    	}
    }

    /**
     * Instructs the environment to play a sequence
     * @param sequence The sequence to play
     */
    public playSequence(sequence: EnvironmentSequence<any>): void {
    	throw new Error('playSequence must be implemented');
    }

    public onLoadingScene(): void {
    	throw new Error('onLoadingScene must be implemented');
    }

    public onSceneLoaded(): void {
    	throw new Error('onSceneLoaded must be implemented');
    }

    /**
     * Pauses the current sequence
     */
    public pauseCurrentSequence(): void {
    	throw new Error('pauseCurrentSequence must be implemented');
    }

    /**
     * Initializes the environment
     */
    public init(): void {
    }

    /**
     * Renders the environment
     */
    public render(onMemoryUpdated: (memory: string) => void, onForceUpdate: () => void, props?: any): any {
    	throw new Error('render must be implemented');
    }
}

/**
 * Properties for the sequence to play
 */
export interface EnvironmentSequence<PropsType> {
    /**
     * The name of the sequence
     */
    sequenceName: string;

    skipAnimations?: string;

    /**
     * Custom properties based on the environment
     */
    props?: PropsType;

    /**
     * Called when the sequence has finished playing
     * result: the received result
     */
    onDone?: (result: string) => void;

    /**
     * Called if there was an error playing the sequence
     * result: the received result
     */
    onError?: (result: string) => void;
  }